import { combineReducers } from 'redux'

import data from './data'
import view from './view'

const reduce = combineReducers({ data, view })

export default reduce



// WEBPACK FOOTER //
// ./src/model/reducers/index.js